/* src/components/Footer.tsx */
import React from 'react';
import { Link } from 'react-router-dom'; // Import Link for navigation
import styles from '../styles/Footer.module.css';

// Import social icons from your source folder
import facebookIcon from '../resources/facebook.png';
import twitterIcon from '../resources/twitter.png';
import instagramIcon from '../resources/instagram.png';
import linkedinIcon from '../resources/linkedin.png';
import youtubeIcon from '../resources/youtube.png';

const socialMedia = [
  { href: '#', src: facebookIcon, alt: 'Facebook' },
  { href: '#', src: twitterIcon, alt: 'Twitter' },
  { href: '#', src: instagramIcon, alt: 'Instagram' },
  { href: '#', src: linkedinIcon, alt: 'LinkedIn' },
  { href: '#', src: youtubeIcon, alt: 'YouTube' },
];

const Footer: React.FC = () => {
  const scrollToTop = (e: React.MouseEvent) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className={styles.footer}>
      <div className={styles['footer-container']}>
        <div className={styles['footer-column']}>
          <div className={styles['footer-logo']}>
            Philosophy<span>Unical</span>
          </div>
          <div className={styles['footer-about']}>
            <p>
              The Department of Philosophy at the University of Calabar is dedicated to cultivating critical thinking and exploring fundamental questions of human existence.
            </p>
            <div className={styles['social-links']}>
              {socialMedia.map(({ href, src, alt }) => (
                <a key={alt} href={href} className={styles['social-link']}>
                  <img src={src} alt={alt} className={styles['social-icon']} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className={styles['footer-column']}>
          <h3>Quick Links</h3>
          <ul className={styles['footer-links']}>
            <li>
              <Link to="/about"><i className="fas fa-chevron-right" /> About Us</Link>
            </li>
            <li>
              <Link to="/programs"><i className="fas fa-chevron-right" /> Academic Programs</Link>
            </li>
            <li>
              <Link to="/about#faculty"><i className="fas fa-chevron-right" /> Faculty Directory</Link>
            </li>
            <li>
              <Link to="/research"><i className="fas fa-chevron-right" /> Research & Publications</Link>
            </li>
            <li>
              <Link to="/events"><i className="fas fa-chevron-right" /> Events & Conferences</Link>
            </li>
            <li>
              <Link to="/resources#students"><i className="fas fa-chevron-right" /> Student Resources</Link>
            </li>
            <li>
              <Link to="/news"><i className="fas fa-chevron-right" /> News & Announcements</Link>
            </li>
          </ul>
        </div>

        <div className={styles['footer-column']}>
          <h3>Programs</h3>
          <ul className={styles['footer-links']}>
            <li>
              <Link to="/programs#undergraduate"><i className="fas fa-graduation-cap" /> Undergraduate</Link>
            </li>
            <li>
              <Link to="/programs#graduate"><i className="fas fa-graduation-cap" /> Masters Program</Link>
            </li>
            <li>
              <Link to="/programs#phd"><i className="fas fa-graduation-cap" /> PhD Program</Link>
            </li>
            <li>
              <Link to="/programs#certificates"><i className="fas fa-graduation-cap" /> Certificate Courses</Link>
            </li>
            <li>
              <Link to="/online-learning"><i className="fas fa-graduation-cap" /> Online Learning</Link>
            </li>
            <li>
              <Link to="/study-abroad"><i className="fas fa-graduation-cap" /> Study Abroad</Link>
            </li>
            <li>
              <Link to="/summer-school"><i className="fas fa-graduation-cap" /> Summer School</Link>
            </li>
          </ul>
        </div>

        <div className={styles['footer-column']}>
          <h3>Contact Us</h3>
          <ul className={styles['contact-info']}>
            <li>
              <i className="fas fa-map-marker-alt" />
              <div>
                Department of Philosophy<br />
                University of Calabar<br />
                Calabar, Nigeria
              </div>
            </li>
            <li>
              <i className="fas fa-phone" />
              <div><a href="tel:+2348012345678">+234 801 234 5678</a></div>
            </li>
            <li>
              <i className="fas fa-envelope" />
              <div><a href="mailto:philosophy@unical.edu.ng">philosophy@unical.edu.ng</a></div>
            </li>
            <li>
              <i className="fas fa-clock" />
              <div>Monday - Friday: 8:00 AM - 5:00 PM</div>
            </li>
          </ul>

          <div className={styles.newsletter}>
            <h3>Newsletter</h3>
            <p>Subscribe to our newsletter for updates and events.</p>
            <form className={styles['newsletter-form']}>
              <input
                type="email"
                className={styles['newsletter-input']}
                placeholder="Your email address"
              />
              <button type="submit" className={styles['newsletter-btn']}>
                <i className="fas fa-paper-plane" />
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className={styles['footer-bottom']}>
        <div className={styles.copyright}>
          &copy; 2025 Department of Philosophy, University of Calabar. All Rights Reserved.
        </div>
        <div className={styles['footer-nav']}>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-of-use">Terms of Use</Link>
          <Link to="/accessibility">Accessibility</Link>
          <Link to="/sitemap">Sitemap</Link>
        </div>
      </div>

      <Link to="#" className={styles['back-to-top']} onClick={scrollToTop}>
        <i className="fas fa-arrow-up" />
      </Link>
    </footer>
  );
};

export default Footer;